import type { InternalDropdownOption } from '~/chords/DropdownTreeSingleSelect/types';
import { updateSelectedRecursive } from '~/chords/DropdownTreeSingleSelect/utils/updateSelectedRecursive';

interface UpdateSelectedOptionsParams {
  prevSelectedOption?: InternalDropdownOption;
  newSelectedOption?: InternalDropdownOption;
}

/**
 * Update the options in the dropdown based on the selected option.
 *
 * @param prevOptions - The previous options in the dropdown.
 * @param param1.prevSelectedOption - The previously selected option, if any.
 * @param param1.newSelectedOption - The newly selected option, if any. Omit to clear.
 * @returns The updated options.
 */
export function updateSelectedOptions(
  prevOptions: InternalDropdownOption[],
  { prevSelectedOption, newSelectedOption }: UpdateSelectedOptionsParams,
) {
  let newOptions = prevOptions;

  // Recursively set hasSelected=false for the previously selected option's parents.
  // and set isSelected=false for the previously selected option.
  newOptions = updateSelectedRecursive(newOptions, {
    isSelected: false,
    indexPath: prevSelectedOption?.optionIndexPath,
  });

  if (!newSelectedOption) {
    return newOptions;
  }

  // Recursively set hasSelected=true for the newly selected option's parents.
  // and set isSelected=true for the newly selected option.
  newOptions = updateSelectedRecursive(newOptions, {
    isSelected: true,
    indexPath: newSelectedOption.optionIndexPath,
  });

  return newOptions;
}
